import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import type {
  UpdatePreferencesRequest,
  UserPreferencesResponse,
} from "../models/api-types";

/**
 * Hook for updating user preferences
 * Mutation for saving size and brand preferences to backend
 */
export const useUpdatePreferences = () => {
  const queryClient = useQueryClient();

  return useMutation<
    UserPreferencesResponse,
    Error,
    UpdatePreferencesRequest
  >({
    mutationFn: async (data: UpdatePreferencesRequest) => {
      return await queryService.updateUserPreferences(data);
    },
    onSuccess: () => {
      // Invalidate user preferences cache to trigger refetch
      queryClient.invalidateQueries({ queryKey: ["preferences", "user"] });
    },
  });
};

